import { render, staticRenderFns } from "./FormComponentConfig.vue?vue&type=template&id=65a15610&scoped=true"
import script from "./FormComponentConfig.vue?vue&type=script&lang=js"
export * from "./FormComponentConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a15610",
  null
  
)

export default component.exports